<template>
  <nav class="sitenav" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img alt="Logo" src="../assets/logo.svg" />
      </a>
    </div>

    <!-- <div class="navbar-start">
        <div v-if="resourceCalendars.length > 0" class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Räume
          </a>

          <div class="navbar-dropdown">
            <router-link v-for="resource in resourceCalendars" :key="resource.id" class="navbar-item"
            :to="{name: 'resource', params: {resourceId: resource.id}}">
              {{ resource.summary }}
            </router-link>
          </div>
        </div>
      </div> -->
    <div class="navbar-item room-name">
      <h1 v-if="updateInProgress" class="subtitle is-info">{{ msg }}</h1>
      <h1 v-if="!updateInProgress" class="subtitle">{{ msg }}</h1>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'navbar',
  props: ['msg'],
  computed: {
    ...mapState(['resourceCalendars', 'isSignedIn', 'updateInProgress'])
  },
  methods: {
    signIn () {
      this.$store.dispatch('signIn')
    },

    signOut () {
      this.$store.dispatch('signOut')
    }
  }
}
</script>

<style lang="scss">
@import "../assets/variables.scss";

.sitenav {
  display: flex;
  justify-content: center;
  height: 6vh;
  padding: 0px 10px;
}

.navbar-item > img {
  width: 100px;
  opacity: 0.7;
}

.navbar-item {
  &.room-name {
    flex: 1;
    width: 100%;
    .subtitle {
      text-align: center;
      width: 100%;
      font-weight: bold;
      color: $turquoise;
      font-family: "Kumbh Sans", sans-serif;
      text-transform: uppercase;
      letter-spacing: 3px;
      position: relative;
      right: 50px;

      @media screen and (max-width: 1020px) {
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
